<template>
  <!--  -->
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-form
        ref="form"
        inline
        :model="searchData"
        label-width=""
    >
      <el-form-item label="代理商" prop="agent_id">
        <select-channel type="sft"  v-model="searchData.agent_id"></select-channel>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input
            style="width: 200px"
            clearable
            v-model="searchData.merchant_id"
            size="mini"
            placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
            style="width: 200px"
            clearable
            v-model="searchData.order_no"
            size="mini"
            placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="getList"
        >搜索
        </el-button>
        <el-button
            type="info"
            size="mini"
            icon="el-icon-refresh"
            @click="reset"
        >重置
        </el-button>
      </el-form-item>
    </el-form>
    <!-- list -->
    <el-table
        :data="list"
    >
      <el-table-column
          prop="source"
          label="来源"
          width="70"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.source == 1" type="success">API</el-tag>
          <el-tag v-else>EXCEL</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="merchant_id"
          label="商户号"
          width="200"
      ></el-table-column>
      <el-table-column
          prop="withdarw_fee"
          label="提现手续费"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="original_amount"
          label="原始金额"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="order_no"
          label="订单号"
          width="200"
      ></el-table-column>
      <el-table-column
          prop="withdraw_type"
          label="提现类型"
          width="80"
      ></el-table-column>
      <el-table-column
          prop="withdraw_amount"
          label="提现金额"
          width="80"
      ></el-table-column>
      <el-table-column
          prop="apply_time"
          label="申请时间"
          width="150"
      ></el-table-column>
      <el-table-column prop="data_json" label="原始数据">
        <template slot-scope="scope">
          <el-tooltip effect="dark" :content="formatJson(scope.row.data_json)" placement="top">
            <div class="ellipsis">
              {{ formatJson(scope.row.data_json) }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
        :total="total"
        :page.sync="searchData.page"
        :limit.sync="searchData.page_size"
        @pagination="getList"
    />
  </div>
</template>

<script>
import {getPosWithdrawPageAPI} from '../api'
import {authBtnMixin} from '@/mixins/authBtnMixin'
import SelectChannel from "@/components/dict/select-channel.vue";

export default {
  name: 'Index',
  components: {SelectChannel},
  mixins: [authBtnMixin],
  // components: { SelectRole, SelectAdminUser },
  data() {
    return {
      rules: [{required: true, message: '该项不能为空', trigger: 'blur'}],
      show_update: false,
      list: [],
      userList: [],
      searchData: {
        agent_id: '',
        merchant_id: '',
        order_no: '',
      },
      total: 0,
      detail: {}
    }
  },
  activated() {
  },
  // mounted() {
  //   this.getList()
  // },

  methods: {
    formatJson(json) {
      if (json && typeof json === 'object') {
        return JSON.stringify(json, null, 2); // 格式化 JSON 字符串
      }
      return json || '无数据';
    },
    async getList() {
      const res = await getPosWithdrawPageAPI(this.searchData)
      this.list = res.data
      this.total = res.total
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  width: 100%;

  .inviter {
    display: inline-flex;
    align-items: center;
    background: #f8f8f9;
    border-radius: 5px;
    padding: 0 20px;

    .inviter-info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .inviter-name {
        font-weight: 600;
      }
    }
  }

  .balance-box {
    display: flex;
    // align-items: center;
    .balance-item {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      background: #f5f5f5;
      border-radius: 5px;
      padding: 0 20px;
      margin-right: 20px;

      span {
        &:last-child {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
